<template>
  <div 
    id="water_loss_ship"
    class="water_supplied"
  >
    <div 
      v-if="receivedData"
      class="water_loss-item"
    >
      <TabsCustomGraphic
          :received-data="receivedData"
          :id="'water_loss_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
          :stacked="false"
      />
    </div> 
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'WaterLoss',
  
  components: {
    TabsCustomGraphic: () => import('@/components/graph/TabsCustomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'water_loss',
      cloneElementId: 'water_loss_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '74,75').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .water_loss-item {
    margin-top: 20px;
  }
</style>